import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../redux/authSlice';

const MyProfile = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const userDetail = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [email, setEmail] = useState('');

    const [activeTab, setActiveTab] = useState('dashboard');
    
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    const makeLogout = () => {
      dispatch(logout());
    }

    const fetchData = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Authorization" : `Bearer ${userDetail.user.token}`
            }
          };
          
        const response = await fetch(`${apiBaseUrl}getsigneduser`, requestOptions)
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        // const data = await response.json();
        // console.log('result',data)
    }
  useEffect(() => {
      if(userDetail?.user?.name == null){
        alert('Please Login')
        navigate(`/`)
      }
      else{
        setFname(userDetail.user.name.split(" ")[0]);
        setLname(userDetail.user.name.split(" ")[1]);
        setEmail(userDetail.user.email);
        fetchData();
      }
      
    },[userDetail])
  return (
    <>
    
    <section class="tg-may-account-wrapp tg">
        <div class="inner">
            <div class="tg-account">
                <div class="account-banner">
                    <div class="inner-banner">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-8 detail">
                                    <div class="inner">
                                        <h1 class="page-title">My Account</h1>
                                        <h3 class="user-name">Hello {fname} {lname}!</h3>
                                        <p class="description">Welcome to our XPO sports wear. Fit for your sports world !!!</p>
                                    </div>
                                </div>
                                <div class="col-md-4 profile">
                                    <div class="profile">
                                        <span class="image">
                                        <img src="https://res.cloudinary.com/templategalaxy/image/upload/v1631257421/codepen-my-account/images/profile_pdpo9w.png" alt="Yash" />
                                    </span>
                                    </div>
                                </div>
                            </div>

                            <div class="nav-area">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class={`nav-link ${activeTab === 'dashboard' ? 'active' : ''}`} onClick={() => handleTabClick('dashboard')} id="dashboard-link" data-toggle="tab" href="#dashboard" role="tab" aria-controls="dashboard" aria-selected="true"><i class="fas fa-tachometer-alt"></i> <span>Dashboard</span></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class={`nav-link ${activeTab === 'orders' ? 'active' : ''}`} onClick={() => handleTabClick('orders')} id="my-order" data-toggle="tab" href="#my-orders" role="tab" aria-controls="my-orders" aria-selected="false"><i class="fas fa-file-invoice"></i> <span>Orders</span></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class={`nav-link ${activeTab === 'address' ? 'active' : ''}`} onClick={() => handleTabClick('address')} id="my-address" data-toggle="tab" href="#address" role="tab" aria-controls="address" aria-selected="false"><i class="fas fa-map-marker-alt"></i> <span>Address</span></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class={`nav-link ${activeTab === 'account' ? 'active' : ''}`} onClick={() => handleTabClick('account')} id="account-detail" data-toggle="tab" href="#account-details" role="tab" aria-controls="account-details" aria-selected="false"><i class="fas fa-user-alt"></i> <span>Account Details</span></a>
                                    </li>
                                    <li class="nav-item">
                                        <a className='nav-link' onClick={() => makeLogout()} id="logout" data-toggle="tab" href="#logout" role="tab" aria-controls="logout" aria-selected="false"><i class="fas fa-sign-out-alt"></i> <span>Logout</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs tg-tabs-content-wrapp">
                    <div class="inner">
                        <div class="container">
                            <div class="inner">
                                <div class="tab-content" id="myTabContent">
                                    <div class={`tab-pane fade ${activeTab === 'dashboard' ? 'show active' : ''}`} id="dashboard" role="tabpanel" aria-labelledby="dashboard-link">
                                        <div class="my-account-dashboard">
                                            <div class="inner">
                                                <div class="row">
                                                    <div class="col-md-4 mb-3">
                                                        <div class="card" onClick={() => handleTabClick('orders')} area-toggle="my-order">
                                                            <div class="card-body">
                                                                <div class="text-center">
                                                                    <a><img src="https://res.cloudinary.com/templategalaxy/image/upload/v1631257421/codepen-my-account/images/orders_n2aopq.png" /></a>
                                                                </div>
                                                                <h2>Your Orders</h2>
                                                                {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <div class="card" onClick={() => handleTabClick('address')} area-toggle="my-address">
                                                            <div class="card-body">
                                                                <div class="text-center">
                                                                    <a><img src="https://res.cloudinary.com/templategalaxy/image/upload/v1631257421/codepen-my-account/images/notebook_psrhv5.png" /></a>
                                                                </div>
                                                                <h2>Your Addresses</h2>
                                                                {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-3">
                                                        <div class="card" onClick={() => handleTabClick('account')} area-toggle="account-detail">
                                                            <div class="card-body">
                                                                <div class="text-center">
                                                                    <a><img src="https://res.cloudinary.com/templategalaxy/image/upload/v1631257421/codepen-my-account/images/login_aq9v9z.png" /></a>
                                                                </div>
                                                                <h2>Account Details</h2>
                                                                {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class={`tab-pane fade ${activeTab === 'orders' ? 'show active' : ''}`} id="my-orders" role="tabpanel" aria-labelledby="my-order">
                                        <table id="my-orders-table" class="table table-striped table-bordered dt-responsive nowrap" style={{width:"100%"}}>
                                            <thead>
                                                <tr>
                                                    <th>Order</th>
                                                    <th>Date</th>
                                                    <th>Status</th>
                                                    <th>Total</th>
                                                    <th class="action">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td>#8083</td>
                                                    <td>Sep 9, 2021</td>
                                                    <td>Completed</td>
                                                    <td>$350</td>
                                                    <td class="action"><a href="#" class="view-order">View Order</a></td>
                                                </tr>

                                                <tr>
                                                    <td>#8283</td>
                                                    <td>Sep 8, 2021</td>
                                                    <td>Pending</td>
                                                    <td>$190</td>
                                                    <td class="action"><a href="#" class="view-order">View Order</a></td>
                                                </tr>

                                                <tr>
                                                    <td>#8483</td>
                                                    <td>Sep 7, 2021</td>
                                                    <td>Completed</td>
                                                    <td>$399</td>
                                                    <td class="action"><a href="#" class="view-order">View Order</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class={`tab-pane fade ${activeTab === 'address' ? 'show active' : ''}`} id="address" role="tabpanel" aria-labelledby="my-address">
                                        <div class="address-form">
                                            <div class="inner">
                                                <form class="tg-form" action="" method="">

                                                    <div class="form-group">
                                                        <label for="inputAddress">Address</label>
                                                        <input type="text" class="form-control" id="inputAddress" placeholder="1234 Main St" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="inputAddress2">Address 2</label>
                                                        <input type="text" class="form-control" id="inputAddress2" placeholder="Apartment, studio, or floor" />
                                                    </div>
                                                    <div class="form-row row">
                                                        <div class="form-group col-md-6">
                                                            <label for="inputCity">City</label>
                                                            <input type="text" class="form-control" id="inputCity" />
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label for="inputState">State</label>
                                                            <select id="inputState" class="form-control">
                                                            <option selected>Choose...</option>
                                                            <option>...</option>
                                                          </select>
                                                        </div>
                                                        <div class="form-group col-md-2">
                                                            <label for="inputZip">Zip</label>
                                                            <input type="text" class="form-control" id="inputZip" />
                                                        </div>
                                                    </div>

                                                    <button type="submit" class="btn btn-primary">Update</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class={`tab-pane fade ${activeTab === 'account' ? 'show active' : ''}`} id="account-details" role="tabpanel" aria-labelledby="account-detail">
                                        <div class="account-detail-form">
                                            <div class="inner">
                                                <form class="tg-form" action="" method="">
                                                    <div class="form-row row">
                                                        <div class="form-group col-md-6">
                                                            <label for="inputfname">First Name</label>
                                                            <input type="text" class="form-control" id="inputfname" placeholder="First Name" />
                                                        </div>
                                                        <div class="form-group col-md-6">
                                                            <label for="inputlname">Last Name</label>
                                                            <input type="text" class="form-control" id="inputlname" placeholder="Last Name" />
                                                        </div>

                                                        <div class="form-group col-md-12">
                                                            <label for="inputdname">Display Name</label>
                                                            <input type="text" class="form-control" id="inputdname" placeholder="Display Name" />
                                                        </div>

                                                        <div class="form-group col-md-12">
                                                            <label for="inputEmail4">Email</label>
                                                            <input type="email" class="form-control" id="inputEmail4" placeholder="Email" />
                                                        </div>
                                                        <div class="form-group col-md-12">
                                                            <label for="inputdob">Birthdate</label>
                                                            <input type="text" class="form-control" id="inputdob" placeholder="MM/DD/YYYY" />
                                                        </div>
                                                    </div>


                                                    <button type="submit" class="btn btn-primary">Update</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  );
}

export default MyProfile;